import ActionButton from 'components/ActionButton';
import CustomLink from 'components/TableLink';
import ToggleSwitch from 'components/ToggleSwitch';
import { tableStyles } from 'css/tableStyles';
import React, { useEffect, useMemo, useState } from 'react';
import DataTable from 'components/DataTable';
import { fetchAllBanners, toggleBannerActiveStatus } from 'services';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const Banners = props => {
  const [banners, setBanners] = useState<Record<string, any>[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [activeLoading, setActiveLoading] = useState<string>('');

  const fetchBanners = async () => {
    try {
      const response = await fetchAllBanners();
      setBanners(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);
  
  const toggleBannerActive = async (id: string, active: boolean) => {
    setActiveLoading(id);
    try {
      await toggleBannerActiveStatus(id);
      await fetchBanners();
      showSuccess(`Banner marked as ${!active ? 'ACTIVE' : 'INACTIVE'} successfully`);
    } catch (e) {
      showError(e);
    } finally {
      setActiveLoading('');
    }
  };

  const columns = useMemo(() => [
    {
      name: 'Banner ID',
      selector: 'objectId',
      sortable: false,
      width: '150px',
      // eslint-disable-next-line react/display-name
      cell: row => (
        <CustomLink
          text={row.objectId}
          linkTo={`/banners/${row.objectId}`}
        />
      ),
    },
    {
      name: 'Text',
      selector: 'text',
      sortable: true,
    },
    {
      name: 'URL',
      selector: 'url',
      sortable: true,
      // eslint-disable-next-line react/display-name
      cell: row => row.url ? (
        <div className={styles['url']}>
          <CustomLink
            text={row.url}
            linkTo={row.url}
          />
        </div>
      ) : '-',
    },
    {
      name: 'Image URL',
      selector: 'image',
      sortable: true,
      // eslint-disable-next-line react/display-name
      cell: row => row.image ? (
        <div className={styles['url']}>
          <CustomLink
            text={row.image._url}
            linkTo={row.image._url}
          />
        </div>
      ) : '-',
    },
    {
      name: 'Active',
      width: '130px',
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <ToggleSwitch
          switchLabel={''}
          disabled={activeLoading === row.objectId}
          checked={row.active}
          onChange={() => toggleBannerActive(row.objectId, row.active)}  
        />
      ),
    },
  ], [activeLoading]);

  return (
    <div>
      <div className={styles['header']}>
        <div className={styles['heading']}>Banners</div>
        <ActionButton
          text={<>Banner <span>+</span></>}
          active={true}
          isLoading={false}
          onClick={() => props.history.push('/banners/create')}
        />
      </div>
      <DataTable
        keyField="objectId"
        columns={columns}
        noHeader={true}
        data={banners}
        highlightOnHover={true}
        defaultSortField="createdAt"
        customStyles={tableStyles}
        pagination={false}
        loading={loading}
      />
    </div>
  );
};

export { Banners };